"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.favoritesQueryClient = exports.FavoritesContext = exports.favoritesQueryClientContext = exports.FavoritesQueryKeys = void 0;
const react_1 = require("react");
const query_1 = require("../query");
var query_2 = require("../query");
Object.defineProperty(exports, "FavoritesQueryKeys", { enumerable: true, get: function () { return query_2.FavoritesQueryKeys; } });
exports.favoritesQueryClientContext = query_1.BarrilQueryClientContext;
const functionNotImplementedError = (functionName) => new Error(`${functionName} not implemented yet`);
exports.FavoritesContext = (0, react_1.createContext)({
    isFavoritesEnabled: false,
    favorites: [],
    hasFavorites: false,
    totalOfFavorites: 0,
    isFull() {
        return __awaiter(this, void 0, void 0, function* () {
            return true;
        });
    },
    favorite() {
        return __awaiter(this, void 0, void 0, function* () {
            throw functionNotImplementedError('favorite');
        });
    },
    isFavorited() {
        return __awaiter(this, void 0, void 0, function* () {
            return false;
        });
    },
    toggleFavorite() {
        return __awaiter(this, void 0, void 0, function* () {
            throw functionNotImplementedError('toggleFavorite');
        });
    },
    unfavorite() {
        return __awaiter(this, void 0, void 0, function* () {
            throw functionNotImplementedError('unfavorite');
        });
    },
});
exports.favoritesQueryClient = query_1.barrilQueryClient;
